import React, { memo, ReactNode } from 'react';

import ThemeProvider from '@plasma/ui.themes.theme-provider';
import { ThemeOverride } from '@plasma/ui.utils.types';

import useZoneMasterHook from './zone-master.hook';
import * as styled from './zone-master.styles';
import themes from './themes';

import EditableTable from '../../components/edit-table';

export interface ZoneMasterProps {
  children?: ReactNode;
  /**
   * Defines custom className
   */
  className?: string;
  /**
   * Defines component's custom style
   */
  style?: React.CSSProperties;
  // add new properties here...
}

type Props = ZoneMasterProps & ThemeOverride;

function ZoneMaster(props: Props) {
  const { children, className, style, size, themeMode } = props;

  const { t,
          dataForColumns,
          columnNames,
          handleSaveAndDeleteFromTable
        } = useZoneMasterHook(props);

  return (
    <ThemeProvider themes={themes} selectedSize={size} selectedMode={themeMode}>
      <styled.ZoneMaster className={`zone-master ${className ?? ''}`.trim()} style={style}>

        <EditableTable
          tableData={dataForColumns}
          tableColumns={columnNames}
          Table_Header='ZONE EDITOR'
          hiddenColumns={['displayseq', 'remarks', 'isactive']}
          handleSave={handleSaveAndDeleteFromTable}
          showActions_ext = {true}
          allowSelection = {false}
          saveReturnType={'row'}
          onlyAddableFields={['zonecode', 'zonename']}
        />

      </styled.ZoneMaster>
    </ThemeProvider>
  );
}

export default memo(ZoneMaster) as unknown as typeof ZoneMaster;
